export { default as RichTextHeading } from './RichTextHeading';
